export type QuestMeta = Record<string, unknown> | null;

export function parseQuestMeta(
  text: string
):
  | { value: QuestMeta; error?: undefined }
  | { value?: undefined; error: string } {
  try {
    const value = text.trim() ? JSON.parse(text) : null;
    if (value !== null && (typeof value !== "object" || Array.isArray(value))) {
      return { error: "Metadata must be a JSON object or null." };
    }
    return { value };
  } catch {
    return { error: "Enter valid JSON, or leave blank to clear metadata." };
  }
}
